import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const LogoSborderIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M20.7023 3.29779L19.5842 4.41581C19.7902 4.62182 19.9442 4.88182 20.0222 5.17383L22.3623 13.904C22.4403 14.194 22.4363 14.496 22.3623 14.778L23.8883 15.186C24.0343 14.64 24.0403 14.058 23.8883 13.494L21.5483 4.76382C21.3963 4.19981 21.1003 3.6978 20.7023 3.29779Z"
        fill={color}
      />
      <path
        d="M8.81396 0.111764L9.22197 1.63779C9.50398 1.56179 9.80598 1.55979 10.096 1.63779L18.8262 3.97784C19.1162 4.05584 19.3762 4.20984 19.5842 4.41585L20.7022 3.29783C20.3022 2.89782 19.8002 2.60181 19.2362 2.45181L10.508 0.111764C9.94399 -0.0402395 9.35998 -0.0342394 8.81597 0.111764H8.81396Z"
        fill={color}
      />
      <path
        d="M0.111816 8.81393L1.63785 9.22194C1.71385 8.93993 1.86185 8.67593 2.07386 8.46392L8.46398 2.07379C8.67599 1.86179 8.93999 1.71179 9.222 1.63779L8.81399 0.111755C8.26798 0.257758 7.76197 0.545764 7.34796 0.957772L0.957833 7.3479C0.543825 7.76191 0.257819 8.26792 0.111816 8.81393Z"
        fill={color}
      />
      <path
        d="M3.29783 20.7022L4.41585 19.5842C4.20984 19.3782 4.05584 19.1182 3.97784 18.8262L1.63779 10.096C1.55979 9.80598 1.56379 9.50398 1.63779 9.22197L0.111764 8.81396C-0.0342394 9.35998 -0.0402395 9.94199 0.111764 10.506L2.45181 19.2362C2.60381 19.8002 2.89982 20.3022 3.29783 20.7022Z"
        fill={color}
      />
      <path
        d="M15.1861 23.8882L14.7781 22.3622C14.4961 22.4382 14.1941 22.4402 13.9041 22.3622L5.17389 20.0221C4.88388 19.9441 4.62388 19.7901 4.41587 19.5841L3.29785 20.7021C3.69786 21.1021 4.19987 21.3981 4.76388 21.5481L13.4941 23.8882C14.0581 24.0402 14.6421 24.0342 15.1861 23.8882Z"
        fill={color}
      />
      <path
        d="M23.8883 15.1861L22.3622 14.7781C22.2862 15.0601 22.1382 15.3241 21.9262 15.5361L15.5361 21.9262C15.3241 22.1382 15.0601 22.2882 14.7781 22.3622L15.1861 23.8883C15.7321 23.7423 16.2381 23.4542 16.6521 23.0422L23.0422 16.6521C23.4562 16.2381 23.7423 15.7321 23.8883 15.1861Z"
        fill={color}
      />
      <path
        d="M7.75781 10.864C7.75781 10.864 9.53185 11.78 10.8779 13.124C12.2219 14.468 13.1379 16.2441 13.1379 16.2441C13.1379 16.2441 13.0439 14.25 13.5359 12.412C14.0279 10.574 15.108 8.89392 15.108 8.89392C15.108 8.89392 13.4279 9.97394 11.5899 10.466C9.75185 10.958 7.75781 10.864 7.75781 10.864Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

LogoSborderIcon.displayName = 'LogoSborderIcon';
